import axios from 'axios';
import { get } from 'lodash';

export default {
    async postPreSignedUploadUrl(payload){
        const apiResponse = await axios.post(`/api/asset/presigneduploadurl`, payload);

        return apiResponse;
    },

    async postNewAsset(assetUri, fileName){
        const apiResponse = await axios.post(`/api/asset/new?assetUri=${encodeURIComponent(assetUri)}&fileName=${encodeURIComponent(fileName)}`);

        return apiResponse;
    }
}